<div class="w-full p-6 flex flex-col justify-center items-center min-h-screen">
  <img
    class="max-w-lg"
    src="assets/img/illustrations/icono_404.svg"
    alt="Error 404" />

  <h3 class="text-black text-[20px] md:text-[22px] lg:text-[24px] font-serif font-bold mt-[40px] mb-[15px] leading-[1.3]" data-aos="fade-up" data-aos-duration="500" data-aos-delay="200">
    ¡Oops! Esa página no se puede encontrar
  </h3>
  <p class="text-[14px] md:text-[15px] lg:text-[16px] md:max-w-[540px] text-[#4c4c4c] leading-[1.7] text-center mb-[15px] lg:mb-[18px]" data-aos="fade-up" data-aos-duration="500" data-aos-delay="300">
    La página que estás buscando está temporalmente fuera de servicio.
  </p>
</div>



